// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"bb7b7f6a","233":"0a0df9fd","684":"fe3e4238","785":"852d1372","842":"13be3e84","930":"1e6cbc43"}[chunkId] + ".chunk.js";
};